export const arInactivePageTranslations = {
	inactivePage: {
		accountInactive: 'الحساب غير نشط',
		accountSuspended: 'تم تعليق حسابك',
		accountSuspendedDesc: 'حساب مطعمك غير نشط حالياً. قد يكون هذا بسبب مشاكل في الدفع أو انتهاك السياسات أو لأسباب إدارية.',
		possibleReasons: 'الأسباب المحتملة:',
		paymentIssues: 'مشاكل في الدفع أو الفواتير',
		policyViolation: 'انتهاك السياسات',
		adminAction: 'إجراء إداري',
		technicalIssues: 'صيانة تقنية',
		whatCanYouDo: 'ما يمكنك فعله:',
		contactSupport: 'اتصل بالدعم',
		contactSupportDesc: 'تواصل مع فريق الدعم للحصول على المساعدة',
		retryCheck: 'إعادة المحاولة',
		retryCheckDesc: 'تحقق من تحديث حالة حسابك',
		supportEmail: 'support@restaurantmenu.com',
		backToLogin: 'العودة لتسجيل الدخول',
		or: 'أو'
	}
}